import React, { useState } from 'react';
import { Activity } from 'lucide-react';
import { HealthStatusModal } from './HealthStatusModal';
import { useHealthStatus } from '../contexts/useHealthStatus';

export const HealthStatusButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { healthStatus, error } = useHealthStatus();

  const handleButtonClick = () => {
    setIsModalOpen(true);
  };

  const getStatusColor = () => {
    if (!healthStatus) return 'bg-gray-500';
    switch (healthStatus.status) {
      case 'healthy':
        return 'bg-green-500';
      case 'degraded':
        return 'bg-yellow-500';
      case 'unhealthy':
        return 'bg-red-500';
      default:
        return 'bg-gray-500';
    }
  };

  return (
    <>
      <button
        data-component="HealthStatusButton"
        onClick={handleButtonClick}
        className={`w-8 h-8 rounded-full shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center ${getStatusColor()} hover:scale-110`}
        title="System Health Status"
      >
        <Activity className="w-4 h-4 text-white" />
      </button>

      {isModalOpen && (
        <HealthStatusModal
          healthStatus={healthStatus}
          error={error}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};
